export const DEFAULT_SENSOR_TIMEZONE = "Europe/Kyiv";

/** Common IANA zones for sensor display (events stored in UTC). */
export const SENSOR_TIMEZONE_OPTIONS = [
    { value: "Europe/Kyiv", label: "Київ (Europe/Kyiv)" },
    { value: "Europe/Warsaw", label: "Варшава (Europe/Warsaw)" },
    { value: "Europe/Bucharest", label: "Бухарест (Europe/Bucharest)" },
    { value: "Europe/Berlin", label: "Берлін (Europe/Berlin)" },
    { value: "Europe/London", label: "Лондон (Europe/London)" },
    { value: "UTC", label: "UTC" },
];

export function timezoneFromSensorConfig(config) {
    const tz = String(config?.timezone || "").trim();
    return tz || DEFAULT_SENSOR_TIMEZONE;
}

/**
 * Backend stores naive UTC timestamps; ISO without Z must be treated as UTC.
 */
export function parseSensorDate(value) {
    if (!value) return null;
    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
    }
    const raw = String(value).trim();
    if (!raw) return null;
    if (/^\d+$/.test(raw)) {
        const ms = Number(raw);
        const date = new Date(ms < 1e12 ? ms * 1000 : ms);
        return Number.isNaN(date.getTime()) ? null : date;
    }
    const hasTz = /([zZ]|[+-]\d{2}:?\d{2})$/.test(raw);
    const normalized = hasTz ? raw : `${raw.includes("T") ? raw : raw.replace(" ", "T")}Z`;
    const date = new Date(normalized);
    return Number.isNaN(date.getTime()) ? null : date;
}

export function formatSensorDateTime(value, timeZone = DEFAULT_SENSOR_TIMEZONE) {
    const date = parseSensorDate(value);
    if (!date) return "-";
    const zone = String(timeZone || DEFAULT_SENSOR_TIMEZONE).trim() || DEFAULT_SENSOR_TIMEZONE;
    try {
        return date.toLocaleString("uk-UA", {
            timeZone: zone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
    } catch (_) {
        return date.toLocaleString("uk-UA");
    }
}
